import Vue from "vue";

Vue.component('form-group', require('components/form/FormGroup.vue').default);
Vue.component('text-input', require('components/form/BootstrapInput.vue').default);
Vue.component('textarea-input', require('components/form/BootstrapTextarea.vue').default);
Vue.component('number-input', require('components/form/NumberInput.vue').default);
Vue.component('phone-input', require('components/form/PhoneInput.vue').default);
Vue.component('money-input', require('components/form/MoneyInput.vue').default);
Vue.component('select-list', require('components/form/SelectList.vue').default);
Vue.component('submit-button', require('components/form/SubmitButton.vue').default);
Vue.component('checkbox', require('components/form/Checkbox.vue').default);
Vue.component('radio-group', require('components/form/RadioGroup.vue').default);
Vue.component('radio', require('components/form/Radio.vue').default);
Vue.component('toggle', require('components/form/Switch.vue').default);
Vue.component('toggle-tile', require('components/form/SwitchTile.vue').default);
Vue.component('button-group', require('components/form/ButtonGroup.vue').default);
Vue.component('per-page', require('components/form/PerPage.vue').default);
Vue.component('card', require('components/Card.vue').default);
Vue.component('loading', require('components/Loading.vue').default);